/*
 *
 *   reducer
 *
 */
import { produce } from "immer";

import {
 LOAD_STATE_SUCCESS,
LOAD_STATE_ERROR,
LOAD_CITY_SUCCESS,
LOAD_CITY_ERROR,
LOAD_COUNTRY_SUCCESS,
LOAD_COUNTRY_ERROR
} from "./constants";

const initialState = {
 stateList:[],
 cityList:[],
 countryList: [],
  loading: false,
  error: false,
  success: false,
  lastUpdate: null,
};

const Reducer = (
  state = initialState,
  { type, cityList,stateList,countryList}
) => {
  return produce(state, (draft) => {
    switch (type) {
    
      case LOAD_STATE_SUCCESS:
        draft.stateList= stateList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_CITY_SUCCESS:
        draft.cityList = cityList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_COUNTRY_SUCCESS:
        draft.countryList = countryList;
        draft.error = false;
        draft.success = false;
        break;
      case LOAD_STATE_ERROR:
      case LOAD_CITY_ERROR:
      case LOAD_COUNTRY_ERROR:
        break;
      default:
        return state;
    }
  });
};

export default Reducer;
